import { MenuItem, Stack, TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateRangeValue } from '@/types/metrics'
import { convertRangeValueToDates, getYesterday } from '@/utils/date-metrics'
import DatePicker from '@/components/data-visualization/DatePicker'
import { DateRange } from './ProjectMetricsDashboard'

type DateRangeFilterProps = {
  selectedDateRange: DateRange
  selectedDateRangeValue: DateRangeValue
  handleUpdateDateRangeData: (
    dateRangeValue: DateRangeValue,
    dateRange: DateRange,
  ) => void
}

export default function DateRangeFilter({
  selectedDateRange,
  selectedDateRangeValue,
  handleUpdateDateRangeData,
}: DateRangeFilterProps) {
  return (
    <Stack direction="row" spacing={1}>
      <TextField
        value={selectedDateRangeValue}
        select
        label="Date Range"
        onChange={(event) => {
          handleUpdateDateRangeData(
            event.target.value as DateRangeValue,
            convertRangeValueToDates(event.target.value),
          )
        }}
        size="small"
        variant="outlined"
        sx={{ height: 40 }}
      >
        <MenuItem value="1day">Yesterday</MenuItem>
        <MenuItem value="2days">2 days</MenuItem>
        <MenuItem value="3days">3 days</MenuItem>
        <MenuItem value="1week">1 Week</MenuItem>
        <MenuItem value="2weeks">2 Weeks</MenuItem>
        <MenuItem value="1month">1 Month</MenuItem>
        <MenuItem value="custom">Custom</MenuItem>
      </TextField>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Start"
          slotProps={{
            textField: {
              variant: 'outlined',
            },
          }}
          onChange={(date) => {
            handleUpdateDateRangeData('custom', {
              ...selectedDateRange,
              startDate: new Date(date),
            })
          }}
          value={selectedDateRange.startDate}
          maxDate={selectedDateRange.endDate}
          sx={{
            width: 160,
          }}
        />
        <DatePicker
          label="End"
          slotProps={{
            textField: {
              variant: 'outlined',
            },
          }}
          onChange={(date) => {
            handleUpdateDateRangeData('custom', {
              ...selectedDateRange,
              endDate: new Date(date),
            })
          }}
          value={selectedDateRange.endDate}
          minDate={selectedDateRange.startDate}
          maxDate={getYesterday(true)}
          sx={{
            width: 160,
          }}
        />
      </LocalizationProvider>
    </Stack>
  )
}
